angular.module('access.Account')
    .factory('CloudPlatformAccountServerRequest', [
        '$http', '$q', '$window', 'ENV',
        ($http, $q, $window, ENV) => {
            const accountServerAddress = ENV.cloudPlatformAccountServerAddress;
            const accountServerLoginPath = `/?return_url=${ENV.relativeUrlRoot}`;

            return {
                /**
                 * Make a GET-request
                 * @param {string} url - URI to request (w/o hostname)
                 * @param {object} [params] - Query params
                 * @param {object} [config] - Additional config
                 * @param {boolean} [config.failOnEmptyResponse=false] - Throw an error, if response.status = 204, or data is empty
                 * @param {boolean} [config.failOnRedirect=false] - Fail the request if server returns 30x-redirect
                 */
                get: function (url, params, config) {
                    if (!accountServerAddress) {
                        return $q.reject(new Error('Account Server address is missing!'));
                    }

                    return $http.get(accountServerAddress + url, angular.extend({
                        ignoreApiErrors: true,
                        ignoreUnauthenticatedErrors: true,
                        headers: {
                            Accept: 'application/json'
                        },
                        params: params
                    }, config)).then(_responseHandler, _errorHandler);
                }
            };

            function _responseHandler(response) {
                return response.data;
            }

            function _errorHandler(response) {
                if (response.status === 401) {
                    $window.location.replace(accountServerLoginPath);
                }

                let message = 'Account Server error';

                if (response.data && response.data.error) {
                    message += `: ${JSON.stringify(response.data.error)}`;
                }

                return $q.reject(new Error(message));
            }
        }
    ]);
